var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _polygon, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _path31, _path32, _path33, _path34, _path35, _path36, _polygon10, _polygon11, _path37, _path38, _polygon12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabEmerald(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Facets",
    viewBox: "0 0 14.98 14.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1 {\n            fill: none;\n            stroke: #049959;\n            stroke-linecap: round;\n            stroke-linejoin: round;\n            stroke-width: 0px;\n            }\n\n            .cls-2 {\n            fill: #025c36;\n            }\n\n            .cls-3 {\n            fill: #025f37;\n            }\n\n            .cls-4 {\n            fill: #01160d;\n            }\n\n            .cls-5 {\n            fill: #024b2c;\n            }\n\n            .cls-6 {\n            fill: #024427;\n            }\n\n            .cls-7 {\n            fill: #02492a;\n            }\n\n            .cls-8 {\n            fill: #024628;\n            }\n\n            .cls-9 {\n            fill: #024226;\n            }\n\n            .cls-10 {\n            fill: #02472a;\n            }\n\n            .cls-11 {\n            fill: #023a22;\n            }\n\n            .cls-12 {\n            fill: #011c10;\n            }\n\n            .cls-13 {\n            fill: #01351f;\n            }\n\n            .cls-14 {\n            fill: #03814b;\n            }\n\n            .cls-15 {\n            fill: #036b3e;\n            }\n\n            .cls-16 {\n            fill: #036a3d;\n            }\n\n            .cls-17 {\n            fill: #037947;\n            }\n\n            .cls-18 {\n            fill: #037343;\n            }\n\n            .cls-19 {\n            fill: #037041;\n            }\n\n            .cls-20 {\n            fill: #7d7d7d;\n            }\n\n            .cls-21 {\n            fill: #9f9f9f;\n            }\n\n            .cls-22 {\n            fill: #049959;\n            }\n\n            .cls-23 {\n            fill: #717171;\n            }\n\n            .cls-24 {\n            fill: #6e6e6e;\n            }\n\n            .cls-25 {\n            fill: #595959;\n            }\n\n            .cls-26 {\n            fill: #38a058;\n            }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m8.48,14.91s-.03,0-.04,0c.28-.03.55-.09.82-.15-.01,0-.03,0-.04,0-.24.06-.48.1-.73.13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m14.4,10.4h0s-.01.02-.01.02c-.22.53-.51,1.02-.85,1.48-.01.02-.02.04-.03.05-.02.02-.04.05-.06.07-.14.18-.28.35-.43.51-.03.04-.07.08-.1.11-.18.19-.36.36-.56.53-.01,0-.02.02-.03.03-.43.36-.89.68-1.39.94-.03.02-.07.03-.1.05-.21.11-.43.2-.65.29-.02,0-.04.02-.06.03,2.62-.98,4.54-3.37,4.83-6.26-.05.46-.15.91-.28,1.34-.08.28-.17.55-.28.82Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m9.38,14.73s-.04.01-.06.02c.26-.07.52-.15.78-.24-.03,0-.05.01-.08.02-.21.08-.42.14-.64.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m8.38,14.93s-.08.01-.12.02c.04,0,.09-.01.13-.02,0,0,0,0-.01,0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m3.2,1.35c.06-.04.12-.08.18-.12-.06.04-.12.08-.18.12Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m2.19,2.2c.18-.18.38-.35.57-.52-.2.16-.39.33-.57.52Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m2.05,2.35c-.18.19-.34.38-.5.59.16-.2.32-.4.5-.59Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m7.49,14.98C3.35,14.98,0,11.63,0,7.49,0,6.95.08,6.43.18,5.92c0,0,0,0,0,0,.09-.41.21-.8.36-1.19.03-.08.05-.16.09-.23h0c.03-.07.07-.13.1-.2.07-.16.15-.31.23-.47,0,0,0,0,0,0,.15-.27.32-.53.5-.78C.55,4.29,0,5.82,0,7.49,0,11.63,3.35,14.98,7.49,14.98c.26,0,.52-.01.77-.04.04,0,.08-.01.12-.02-.29.03-.59.05-.89.05Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m12.33,13.2c-.43.36-.89.68-1.39.94.5-.26.97-.57,1.39-.94Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m13.45,12.02c-.14.18-.28.35-.43.51.15-.17.29-.34.43-.51Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m10.84,14.19c-.21.11-.43.2-.65.29.22-.09.44-.18.65-.29Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m.97,3.83s0,0,0,0c-.08.15-.16.31-.23.47,0,0,0,0,0,0,.07-.16.15-.32.23-.47Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m12.92,12.65c-.18.19-.36.36-.56.53.19-.17.38-.34.56-.53Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m14.28,10.63c-.08.16-.15.32-.24.48-.15.27-.32.53-.5.78.33-.46.62-.95.85-1.48h0c-.03.08-.07.14-.1.21Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m8.48,14.91c.25-.03.49-.08.73-.13-.24.06-.48.1-.73.13Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m9.38,14.73c.22-.06.43-.12.64-.2-.21.08-.42.14-.64.2Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m14.4,10.4c.11-.26.2-.54.28-.82-.06.21-.13.41-.21.61-.03.07-.05.13-.07.2h0Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m.74,4.3s0,0,0,0c-.03.07-.07.13-.1.2h0c.03-.07.07-.13.1-.2Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m10.84,14.19s.07-.03.1-.05c.5-.26.97-.57,1.39-.94.01,0,.02-.02.03-.03.19-.17.38-.34.56-.53.04-.04.07-.08.1-.11.15-.16.29-.34.43-.51.02-.02.04-.05.06-.07-.76,1.02-1.79,1.82-2.96,2.34v.02s-.04,0-.04,0c-.92.4-1.92.63-2.99.63s-2.09-.23-3.02-.64h0s0,0,0,0c-1.73-.77-3.12-2.17-3.87-3.92h0s0,0,0,0C.24,9.48.03,8.49.03,7.45c0-.52.05-1.04.16-1.53C.08,6.43,0,6.95,0,7.49,0,11.63,3.35,14.98,7.49,14.98c.3,0,.6-.02.89-.05,0,0,0,0,.01,0,.01,0,.03,0,.04,0,.02,0,.03,0,.04,0,.25-.03.49-.08.73-.13.01,0,.03,0,.04,0,.03,0,.05-.01.08-.02.02,0,.04-.01.06-.02.22-.06.43-.12.64-.2.03,0,.05-.01.08-.02,0,0,.02,0,.03-.01.02,0,.04-.02.06-.03.22-.09.44-.18.65-.29Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: ".97 3.83 .97 3.83 .97 3.83 .97 3.83"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m.74,4.29c.07-.16.15-.31.23-.47"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m4.6.58l.02-.04c-.44.18-.85.42-1.24.68-.06.04-.12.08-.18.12-.15.11-.3.21-.44.33-.2.16-.39.33-.57.52-.05.05-.09.1-.14.15-.18.19-.34.38-.5.59-.02.02-.03.04-.05.06.8-1.06,1.86-1.9,3.1-2.41Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m7.49,0C8.52,0,9.49.21,10.38.58h.09C9.56.18,8.57-.04,7.52-.04s-2,.21-2.89.58h.05C5.54.19,6.49,0,7.49,0Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m10.52.64c1.73.77,3.12,2.17,3.86,3.91l.03.02c-.75-1.8-2.16-3.24-3.95-4.01l.05.07Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m14.43,4.67c.35.87.55,1.82.55,2.82s-.18,1.86-.51,2.7c.08-.2.15-.4.21-.61.13-.43.23-.88.28-1.34.03-.26.05-.52.05-.79,0-1-.21-1.95-.57-2.82v.04Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m.62,10.38l.53-2.83-.52-3.05c-.03.08-.06.16-.09.23-.15.38-.28.78-.36,1.19,0,0,0,0,0,0-.1.49-.16,1.01-.16,1.53,0,1.04.21,2.03.59,2.92Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m.62,10.38c.74,1.75,2.13,3.15,3.87,3.92l-1.49-2.31-2.37-1.61Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m7.52,1.02l2.86-.44C9.49.21,8.52,0,7.49,0s-1.95.19-2.82.55l2.85.47Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m12.14,2.99l2.24,1.56c-.74-1.74-2.13-3.15-3.86-3.91l1.62,2.35Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m14.28,10.63c.03-.07.07-.14.1-.21l-2.29,1.44-1.55,2.43c1.18-.52,2.2-1.33,2.96-2.34.01-.02.02-.04.03-.05.18-.25.35-.51.5-.78.09-.16.16-.32.24-.48Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m4.5,14.3c.92.41,1.94.64,3.02.64s2.07-.23,2.99-.63l-3.13-.42-2.88.42Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m.97,3.83h0c-.08.15-.16.31-.23.47-.03.07-.07.13-.1.2l2.34-1.52.5,2.79-.49-2.79,1.62-2.4c-1.24.52-2.31,1.36-3.1,2.41-.01.02-.02.04-.03.05-.18.25-.35.51-.5.78Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m13.9,7.61l.5,2.78c.03-.07.05-.13.07-.2.32-.84.51-1.75.51-2.7s-.2-1.95-.55-2.82l-.53,2.94Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "5.82 11.55 9.18 11.58 11.56 9.13 11.59 5.77 9.33 3.32 5.89 3.33 3.48 5.77 3.44 9.17 5.82 11.55"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "7.52 1.02 5.89 3.33 9.33 3.32 7.52 1.02"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "5.82 11.55 3.44 9.17 3 11.99 5.82 11.55"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "9.18 11.58 5.82 11.55 7.38 13.89 9.18 11.58"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "11.59 5.77 11.56 9.13 13.9 7.61 11.59 5.77"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "11.56 9.13 9.18 11.58 12.1 11.87 11.56 9.13"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "3.44 9.17 3.48 5.77 1.15 7.54 3.44 9.17"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "2.99 2.98 3.48 5.77 5.89 3.33 2.99 2.98"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.33 3.32 11.59 5.77 12.14 2.99 9.33 3.32"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1.15 7.54 3.48 5.77 2.98 2.98 .63 4.5 .63 4.5 .63 4.5 1.15 7.54"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m4.6.58s.05-.02.07-.03h-.05s0,0,0,0l-.02.04Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m4.6.58l-1.62,2.4,2.91.35,1.63-2.31-2.85-.47s-.05.02-.07.03Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m14.38,4.55s.03.08.05.12v-.04s.01-.04.01-.04l-.03-.02-.03-.02Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m11.59,5.77l2.3,1.84.53-2.94s-.03-.08-.05-.12l-2.24-1.56-.55,2.78Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m10.38.58s.09.04.14.06l-.05-.07h-.09Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m12.14,2.99l-1.62-2.35s-.09-.04-.14-.06l-2.86.44,1.81,2.3,2.81-.33Z"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "3.44 9.17 1.15 7.54 .62 10.38 .62 10.38 .62 10.38 3 11.99 3.44 9.17"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "5.82 11.55 3 11.99 4.49 14.3 4.49 14.31 4.5 14.3 7.38 13.89 5.82 11.55"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m14.38,10.42h0s.01-.01.01-.01h0s0-.02,0-.02c0,.01,0,.02-.01.03Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m14.38,10.42s0-.02.01-.03l-.5-2.78-2.34,1.52.54,2.73,2.29-1.44Z"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "9.18 11.58 7.38 13.89 10.51 14.31 10.53 14.31 10.54 14.29 12.1 11.87 9.18 11.58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabEmerald);
export default __webpack_public_path__ + "static/media/LabEmerald.befe47837f75cc9aeadc146c62d5677c.svg";
export { ForwardRef as ReactComponent };